import * as types from './mutation-types'

export default {
    [types.LOAD_KARAOKES](state, data) {
        if(data.pagination.current_page === 1) {
            state.karaokes.data = data.karaokes
            state.karaokes.pagination = data.pagination
        } else {
            state.karaokes.data = [...state.karaokes.data, ...data.karaokes]
            state.karaokes.pagination = data.pagination
        }
    },

    [types.ADD_KARAOKE](state, karaoke) {
        const index = state.karaokes.data.findIndex(k => k.id === karaoke.id)
        if (index !== -1) {
            state.karaokes.data[index] = { ...state.karaokes.data[index], ...karaoke }
        }else {
            state.karaokes.data.push(karaoke)
        }
    },

    [types.LOAD_KARAOKE_DISC_JOCKEYS](state, {karaokeId, discJockeys}) {
        state.karaokeDiscJockeys = {...state.karaokeDiscJockeys, [karaokeId]: discJockeys}
    },

    [types.ADD_KARAOKE_DISC_JOCKEYS](state, {karaokeId, discJockey}) {
        let karaoke = state.karaokeDiscJockeys[karaokeId] || []
        karaoke.push(discJockey)
        state.karaokeDiscJockeys = {...state.karaokeDiscJockeys, [karaokeId]: karaoke}
    },

    [types.REMOVE_KARAOKE_DISC_JOCKEYS](state, {karaokeId, ids}) {
        let karaoke = state.karaokeDiscJockeys[karaokeId] || []
        karaoke = karaoke.filter(x => !ids.includes(x.id))
        state.karaokeDiscJockeys = {...state.karaokeDiscJockeys, [karaokeId]: karaoke}
    },

    [types.LOAD_PARTICIPATORS](state, participators) {
         state.participators = participators
    },


}
